var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{class:("text-center " + (_vm.type === 'basic' ? 'fix-chip' : '')),attrs:{"small":"","color":_vm.color}},[_vm._v("\n  "+_vm._s(_vm.currentValue)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }